/**
 * Gameplay category of an obstacle = the action the player needs to get past it.
 * Used by the generator and the sequence validator. Collision itself is purely
 * collider based, so a JUMP obstacle is "jumpable" because of its collider height.
 */
export const ObstacleType = {
  Jump: 'JUMP',
  DoubleJump: 'DOUBLE_JUMP',
  Slide: 'SLIDE',
  LaneChange: 'LANE_CHANGE',
  Timing: 'TIMING',
  Turn: 'TURN',
} as const;

export type ObstacleType = (typeof ObstacleType)[keyof typeof ObstacleType];

export const ALL_OBSTACLE_TYPES: readonly ObstacleType[] = Object.values(ObstacleType);
